import React, { FC } from 'react';

//devextreem
import { Popup } from 'devextreme-react/popup';

import ModalFooter from 'components/appModalFooter';

import { useDeleteMethodOfReceptionMutation } from 'bus/methodOfReception/services';

type Props = {
  detailId: number | null;
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
};

export const DeleteModal: FC<Props> = ({ changeVisible, detailId, refresh, visible }) => {
  const [deleteMethodOfReception, { isLoading }] = useDeleteMethodOfReceptionMutation();

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();
    if (detailId)
      await deleteMethodOfReception({ id: detailId })
        .unwrap()
        .then(() => {
          refresh();
          changeVisible(false);
        });
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        showTitle={true}
        title="Подтвердите действие"
        width={400}
        height={160}
      >
        <div className="modal-block">
          <form onSubmit={handleSubmit}>
            <div className="modal-block__content">Вы действительно хотите удалить запись?</div>
            <ModalFooter
              useSubmitBehavior={false}
              handleSubmit={handleSubmit}
              hideModal={() => changeVisible(false)}
              textConfirm="Удалить"
              typeConfirm="danger"
              disabledSubmit={isLoading}
            />
          </form>
        </div>
      </Popup>
    </div>
  );
};
